import React, { useEffect } from 'react';
//import DateRangeIcon from '@material-ui/icons/DateRange';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
// import StarIcon from '@material-ui/icons/Star';

// import Typography from '@material-ui/core/Typography';
// import HeightIcon from '@material-ui/icons/Height';
// import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { makeStyles } from '@material-ui/core/styles';
// import { InputAdornment } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import {
    // Button,
    Grid,
    Select,
    MenuItem,
    FormControl,
    // ListItemIcon,
    // ListItemText,
    // ListItem,
    // List
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
// import EditOutlinedIcon from "@material-ui/core/SvgIcon/SvgIcon";
import MenuDropdown from '../small-components/MenuDropdown/MenuDropdown';

export default function FilterBox(props) {

    const newStyles = makeStyles({
        sortCol: {
            ' .arrow-outer': {
                transform: 'rotate(0deg)',
                transition: 'all 0.3s  ease-in-out'
            }
        },
        menuDropdown: {
            marginTop: '1rem',
            marginBottom: '1rem',
        },
        menuDropdownInput: {
            padding: '8.5px 10px',
            paddingRight: '31px !important',
            // fontWeight: 400
            fontWeight: 300
        },
        menuDropdownIcon: {
            marginRight: '5.5px',
        },
        error: {
            border: "1px solid #db263b !important"
        }
    });

    const [sort, setSort] = React.useState('recent');

    const handleSort = (event) => {
        setSort(event.target.value);
        props.handleSort(event.target.value);
    };

    const classes = newStyles();
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const inputHandler = (e) => {
        setValue(e);
        props.change(e);
        setError(false);
    }
    const clearInput = () => {
        setValue('');
        props.change('');
        document.getElementById("tags").value = "";
    }
    const onsubmit = (event) => {
        if (['INPUT'].indexOf(event.target.tagName)) {
            return;
        }
        const { keyCode } = event;
        if (keyCode === 13 && value === "") {
            setError(true);
        }
    };
    useEffect(() => {
        document.getElementById("tags").addEventListener('keydown', onsubmit);

    }, [onsubmit])
    return (
        <Grid container spacing={3}>
            <Grid item xs={3}>
                <div className="input-field col" style={{ width: 300 }}>
                    <label>
                        <i className="material-icons icon">
                            <SearchIcon htmlColor='#000000' />
                        </i>
                    </label>
                    <input type="text"
                        className={`autoComplete ${error && classes.error}`}
                        onChange={(e) => inputHandler(e.target.value)}
                        defaultValue={props.defaultSearchValue && props.defaultSearchValue}
                        placeholder={`${props.placeholder ? props.placeholder : "Search Estimates"}`}
                        id="tags" />
                    {value !== "" && (
                        <ClearIcon onClick={clearInput} className="cross" />
                    )}

                </div>
            </Grid>
            <div className={props.classes.grow} />
            <Grid item className={props.classes.sortCol}>
                <MenuDropdown
                    className={classes.menuDropdown}
                    value={props.age}
                    onChange={props.handleChange}
                    displayEmpty
                    selectInputProps={{
                        classes: {
                            root: classes.menuDropdownInput,
                            icon: classes.menuDropdownIcon,
                        },
                    }}
                    inputProps={{ 'aria-label': 'Type' }}
                    IconComponent={ExpandMoreIcon}
                    getContentAnchorEl={null}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        }
                    }}

                >
                    <MenuItem value="">Type</MenuItem>
                    <MenuItem value={"time-based"}>Time Based</MenuItem>
                    <MenuItem value={"task-based"}>Task Based</MenuItem>
                </MenuDropdown>

            </Grid>
            <Grid item className={props.classes.sortCol}>
                <MenuDropdown
                    className={classes.menuDropdown}
                    selectInputProps={{
                        classes: {
                            root: classes.menuDropdownInput,
                            icon: classes.menuDropdownIcon,
                        },
                    }}
                    getContentAnchorEl={null}
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        }
                    }}
                    value={sort}
                    change={handleSort}
                >
                    <MenuItem value="favourites">Favorites</MenuItem>
                    <MenuItem value="recent">Recent</MenuItem>
                    <MenuItem value="ascending">Ascending</MenuItem>
                    <MenuItem value="descending">Descending</MenuItem>
                </MenuDropdown>

            </Grid>
        </Grid>
    )
}